import { Box, Breadcrumbs } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { StyledBreadcrumb } from "common-fe";

/**
 * Reusable breadcrumb using the chevron-shape `StyledBreadcrumb` pill
 * from common-fe (matches account-fe). Crumbs with a `to` field
 * navigate via react-router-dom — that's how a scorer bails out of
 * the Scoring Form without saving: clicking a crumb unmounts the
 * form and the in-flight sheet state drops on the floor.
 *
 * `position` (first/middle/last/single) is auto-computed per index so
 * the chevron shapes connect properly.
 *
 * @param {{label: string, to?: string}[]} items
 */
export default function PageBreadcrumbs({ items }) {
  const navigate = useNavigate();
  const count = items.length;

  return (
    <Box sx={{ mb: 2 }}>
      <Breadcrumbs separator="">
        {items.map((item, index) => {
          let position = "middle";
          if (count === 1) position = "single";
          else if (index === 0) position = "first";
          else if (index === count - 1) position = "last";

          const isLast = index === count - 1;
          const clickable = !isLast && item.to;

          return (
            <StyledBreadcrumb
              key={`${item.label}-${index}`}
              label={item.label}
              position={position}
              component={clickable ? "button" : "div"}
              onClick={clickable ? () => navigate(item.to) : undefined}
              sx={{
                cursor: clickable ? "pointer" : "default",
                border: "none",
                font: "inherit",
              }}
            />
          );
        })}
      </Breadcrumbs>
    </Box>
  );
}
